import React from "react";

interface SelectedTimeProps {
    placeholder:string,
    start:number,
    end:number,
    onChangeHandler: (selectedTime:number) => void
}

function makeOptions(start, end) {
    let options = new Array();
    for(let i=start; i<=end; i++) {
        options.push(<option key={`visitTIme${start}${end}Key${i}`} value={i}>{`${i}:00`}</option>);
    }
    return options;
}
export default function VisitTimeComponent({placeholder, start, end, onChangeHandler}:SelectedTimeProps) {

    let options = makeOptions(start, end);

    return (
        <select className="nv_select_box" onChange={
            (e) => onChangeHandler(Number(e.target.value))
        }>
            <option selected={true} disabled={true}>{placeholder}</option>
            {options.map((row) => row)}
        </select>
    )
}